import React, { ReactElement } from 'react'
import { AppId } from 'src/app/AppId'
import { LandingPage } from 'src/ui/layout-page/landing/LandingPage'

export const LandingPageEs = (): ReactElement => {
  return <LandingPage app={AppId.EASY_SET} />
}
